import Vue from 'external/Vue';
import Vuex from 'external/Vuex';
import createApp from './createApp';

const APP_ID = '#consent-popup-mweb';

const { app } = createApp({ Vue, Vuex });

app.$mount(APP_ID, true);
